import { singleAdvertisementDetailsService } from '@/api/services/advertisements/advertisementsService'
import BigContainer from '@/components/layout/containers/BigContainer'
import PageWrap from '@/components/layout/containers/PageWrap'
import Footer from '@/components/layout/footer/Footer'
import Header from '@/components/layout/header/Header'
import PageLoading from '@/components/specific/loaders/LoadingSpinner'
import { Seo } from '@/components/specific/seo/Seo'
import { Button } from '@/components/ui/common/Button'
import { useQuery } from '@tanstack/react-query'
import { useCallback } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import DisplayPick from '../Viewers/_components/DisplayPick'
import AdDetails from './_components/AdDetails'

function GraphicsDetails() {
  const { id } = useParams<string>()
  const navigate = useNavigate()

  const { data, isLoading, isPending } = useQuery({
    queryKey: ['advertisement', id],
    queryFn: () => singleAdvertisementDetailsService(id!),
    enabled: !!id,
    select: (data) => {
      if (data.success) {
        return data.data
      }
      return undefined
    },
    refetchOnWindowFocus: false
  })

  const handleGenerateAgain = useCallback(() => {
    if (!data) return
    navigate('/', {
      state: {
        generateData: {
          ...data.job,
          shopLogoFileTmp: data.job.shopLogoFileId,
          productImageFileTmp: data.job.productImageFileId,
          templateFileTmp: data.job.templateFileId
        }
      }
    })
  }, [data])

  const handlePassData = useCallback(() => {
    if (!data) return
    navigate('/', {
      state: {
        data: {
          ...data.job,
          shopLogoFileTmp: data.job.shopLogoFileId,
          productImageFileTmp: data.job.productImageFileId,
          templateFileTmp: data.job.templateFileId
        }
      }
    })
  }, [data])

  if (isLoading || isPending) return <PageLoading />

  return (
    <>
      <Seo title="Grafika | ShopAdverts" />
      <Header />
      <PageWrap className="justify-normal px-2 pt-28 md:px-0">
        <BigContainer>
          <AdDetails data={data} />
        </BigContainer>
        <div className="mx-auto mt-10 grid w-full max-w-6xl grid-cols-1 gap-4 px-2 pb-24 md:grid-cols-3 md:gap-10 md:px-24">
          <Button onClick={handlePassData}>Przejdź do formularza z danymi</Button>
          <Button onClick={handleGenerateAgain}>Generuj ponownie</Button>
          <DisplayPick id={id!} />
        </div>
      </PageWrap>

      <Footer />
    </>
  )
}

export default GraphicsDetails
